<template>
  <div>
    <div class='baby_see'>
    <div class='goods_details_text'>大家都在看</div>
    <div class="swiper-container today_goods_pic_wrapper">
      <div class="swiper-wrapper">
       <router-link :to="{ name: 'item', params: { id: item.num_iid },query:{tkUrl:item.tkUrl,coupon:item.couponPrice}}" class="swiper-slide today_pic_cell_wrapper" v-for="item in babySeeInfo" :key="item.num_iid" >
         <div class="today_pic_cell">
           <img :src="item.pict_url" class="today_goods_pic"  />
           <span class="coupon_money">券{{item.couponPrice}}元</span>
           <p class="today_btm_coupon">
             {{item.title}}
           </p>
         </div>
       </router-link>

   </div>


    </div>
  </div>
  </div>
</template>
<script type = "text/ecamscript-6">
import Vue from 'vue'
import SwiperVue from 'swiper'
  export default {
    name:"everyBodySee",
    props:['keyWord'],
    data(){
      return{
        babySeeInfo:[]
      }
    },
    created (){
      this.login()
    },

    methods:{
      /*axios调用数据*/
       login () {
         this.url = "https://souquan.wang/api/searchAPI.php?adzone_id=106344537&has_coupon=true&page_no=1&page_size=20&is_overseas=false&is_tmall=true&sort=tk_rate_des&q="+this.keyWord
         //console.log(this.url )
         this.$ajax.autoService
             .login(this.url)
             .then((res) => {
               this.babySeeInfo = this.babySeeInfo.concat(res.data.result_list.map_data.map(function(item){
                 if(item.coupon_id){
                   item.tkUrl = item.coupon_share_url
                 }
                 else{
                   item.tkUrl = item.url
                 }
                 item.couponPrice = item.coupon_info.match(/[\d\.]+/g)[1]
                 item.finalPrice = (item.zk_final_price-item.couponPrice).toFixed(2)
                //item.coupon_price = parseInt(item.coupon_price)
                //item.title = item.title
                var temp = item.pict_url
                temp = temp.replace('https:', '')
                temp = temp.replace('http:', '')
                item.pict_url = "https:" + temp
                 return item
               }))
               //this.loading = false
               //console.log(this.babySeeInfo)
               this.$nextTick(()=>{
                 var mySwiper = new SwiperVue('.swiper-container', {
                   "autoplay": "true",
                   "slidesPerView" : '3.4',
                   'direction': 'horizontal',
                    'loop': "true",
                 })
               })
             }, (res) => {
                 console.log("error")
                 this.REQUIRE = true;
             })
        },
      },
    mounted(){

    }
  }
</script>
<style lang="stylus">
  .baby_see
    width:100%
    margin-top:20px
    background:#fff
    padding:25px 0 25px 30px
    box-sizing:border-box
    .goods_details_text
      font-size:28px
      color:#333
    .swiper-container
      width:720px
      position:relative
      margin-top:20px
      box-sizing:border-box
      .today_pic_cell
        width:208px
        height:208px
        position:relative
        .today_goods_pic
          width:208px
          height:208px
        .coupon_money
          height:34px
          padding:0 8px
          display:inline-block
          background:linear-gradient(to right,#f80,#f40)
          position:absolute
          top:0px
          left:0px
          color:#fff
        .today_btm_coupon
          width:100%
          font-size:20px
          color:#fff
          height:35px
          line-height:35px
          background:rgba(0,0,0,0.5)
          position:absolute
          left:0px
          bottom:0px
          padding:0 10px
          box-sizing:border-box
          overflow:hidden
          text-overflow: ellipsis
          white-space:nowrap

</style>



// WEBPACK FOOTER //
// src/components/item/everyBodySee.vue